import React from "react";

function AchievementsSection() {
  const achievements = [
    {
      title: "Award-Winning Ventures",
      description: "Recognized globally for our innovative business solutions.",
      icon: "/assets/icons/trophy.png", 
    },
    {
      title: "Customer Satisfaction",
      description: "98% satisfaction rate across all our services.",
      icon: "/assets/icons/customer-review.png", 
    },
    {
      title: "Industry Leadership",
      description: "Leading the way in technology, fashion, and real estate.",
      icon: "/assets/icons/leader.png", 
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-100 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-extrabold text-primary mb-6">
          Our Achievements
        </h2>
        <p className="text-lg text-gray-600 mb-12">
          Celebrating milestones that define our excellence.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center bg-white shadow-lg rounded-lg p-8 hover:scale-105 transform transition-all"
            >
              <img
                src={achievement.icon}
                alt={`${achievement.title} Icon`}
                className="w-16 h-16 mb-6"
              />
              <h3 className="text-xl font-bold text-secondary mb-3">
                {achievement.title}
              </h3>
              <p className="text-gray-600">{achievement.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AchievementsSection;
